var _rect, _rect2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F5F6F8",
    stroke: "#E4E5E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#898D9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8417 25.0408C21.5385 24.7071 21.0178 24.6946 20.6989 25.0135C20.4049 25.3075 20.3893 25.7791 20.6631 26.0919L26.6471 32.9286L36.4091 22.2972C36.7394 21.9374 36.7276 21.3812 36.3822 21.0358C36.014 20.6676 35.4128 20.682 35.0627 21.0674L26.6471 30.3296L21.8417 25.0408Z",
    fill: "#F5F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8502 24.9863C16.5134 24.6152 15.9348 24.6012 15.5804 24.9555C15.2538 25.2821 15.2364 25.806 15.5406 26.1536L20.7755 32.1344C21.1469 32.5587 21.8041 32.5675 22.1866 32.1533C22.5201 31.7921 22.5225 31.2359 22.1921 30.8718L16.8502 24.9863Z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5172 27.4638L31.9915 21.536C32.3314 21.168 32.3201 20.5972 31.9658 20.2429C31.6013 19.8785 31.0104 19.8785 30.646 20.2429L25.0448 25.8441L26.5172 27.4638Z",
    fill: "#F5F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticSuccessIcon);
export default __webpack_public_path__ + "static/media/statistic-success-icon.3483d27df076b53b293ced98f283624e.svg";
export { ForwardRef as ReactComponent };